import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IVenueSource } from '@core/interfaces/venue/venue-source.interface';
import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';
import { CITY_INFO, VENUE_LIST } from '@core/mocks/venue/venue.mock';
import { ICityInfo } from '../../interfaces/venue/city-info.interface';

@Injectable()
export class VenueSourceMockService implements IVenueSource {

  getList(): Observable<IListResult<IVenueListItem>> {
    return of(VENUE_LIST).pipe(delay(500));
  }

  getCityByZipCode(zipCode: string): Observable<ICityInfo> {
    return of(CITY_INFO).pipe(delay(250));
  }

}
